// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2u28I","range":"MonthRangeSwitch_range__2jFDC","disabled":"MonthRangeSwitch_disabled__39LVV"};